// extracted by mini-css-extract-plugin
module.exports = {"menu":"Dropdown_menu__Hq_KW","dropdown":"Dropdown_dropdown__L0lHA"};